<template>
  <div class="goods-order">
    <Form :model="formItem"
          ref="formItem"
          :inline="true"
          action="javascript:void(0)">
      <FormItem>
        <Input v-model="formItem.key"
               placeholder="输入订单编号/下单用户手机号..."
               style="width: 260px;" />
      </FormItem>
      <FormItem>
        <Input v-model="formItem.pay_order_num"
               placeholder="输入支付单号..."
               style="width: 260px;" />
      </FormItem>
      <FormItem>
        <Input v-model="formItem.name"
               placeholder="商家名称/商品名称..."
               style="width: 260px;" />
      </FormItem>
      <FormItem>
        <Select v-model="formItem.pay_status"
                clearable
                filterable
                placeholder="支付状态...">
          <Option v-for="item in payStatusList"
                  :value="item.id"
                  :key="item.id">{{item.name}}</Option>
        </Select>
      </FormItem>
      <FormItem>
        <Select v-model="formItem.status"
                clearable
                filterable
                placeholder="订单状态...">
          <Option v-for="item in statusList"
                  :value="item.id"
                  :key="item.id">{{item.name}}</Option>
        </Select>
      </FormItem>
      <FormItem>
        <Select v-model="formItem.ship_status"
                clearable
                filterable
                placeholder="发货状态...">
          <Option v-for="item in shipList"
                  :value="item.id"
                  :key="item.id">{{item.name}}</Option>
        </Select>
      </FormItem>
      <FormItem>
        <Select v-model="formItem.receipt_status"
                clearable
                filterable
                placeholder="收货状态...">
          <Option v-for="item in receiptStatusList"
                  :value="item.id"
                  :key="item.id">{{item.name}}</Option>
        </Select>
      </FormItem>
      <FormItem>
        <Select v-model="formItem.pay_name"
                clearable
                filterable
                placeholder="收单机构">
          <Option v-for="item in payNameList"
                  :value="item.id"
                  :key="item.id">{{item.name}}</Option>
        </Select>
      </FormItem>
      <FormItem>
        <Button type="primary"
                @click="renderTable('formItem')">筛选</Button>&nbsp;
        <Button type="success"
                :loading="exportLoading"
                @click="exportOrder()">导出未发货订单</Button>&nbsp;
        <Button type="success"
                @click="showImportModel()">批量发货</Button>
      </FormItem>
    </Form>
    <Table border
           max-height="600"
           :columns="list"
           :data="tablelist"
           :loading="dataloading"
           class="B2CList"></Table>
    <!-- 详情弹层 start-->
    <Drawer width="50"
            v-model="modal1"
            title="订单详情"
            :mask-closable="false"
            @on-cancel="modal1 = false">
      <Row>
        <Col :xs="24"
             :md="24">
        <div v-model="detaildata">
          <div>
            <span class="key_name">支付单号:</span>
            <span>{{detaildata.pay_order_num}}</span>
          </div>
          <div>
            <span class="key_name">支付方式:</span>
            <span>{{detaildata.pay_name}}</span>
          </div>
          <div>
            <span class="key_name">订单编号:</span>
            <span>{{detaildata.order_num}}</span>
          </div>
          <div>
            <span class="key_name">收件人:</span>
            <span>{{detaildata.person}}</span>
          </div>
          <div>
            <span class="key_name">收件电话:</span>
            <span>{{detaildata.phone}}</span>
          </div>
          <div>
            <span class="key_name">收件地址:</span>
            <span>{{detaildata.address}}</span>
          </div>
          <div>
            <span class="key_name">快递名称:</span>
            <span>{{detaildata.logistics_name}}</span>
          </div>
          <div>
            <span class="key_name">快递编号:</span>
            <span>{{detaildata.logistics_code}}</span>
          </div>
          <div v-if="wxreturnmoney_method">
            <span class="key_name">融宝返回:</span>
            <span>{{detaildata.wxreturn_status}}</span>
          </div>
          <div v-if="wxreturnmoney_status">
            <span class="key_name">融宝退款返回:</span>
            <span>{{detaildata.wxreturnmoney_status}}</span>
          </div>
        </div>
        </Col>
        <Col :xs="24"
             :md="24">
        <Table border
               stripe
               :columns="columsgood"
               :data="datagood"></Table>
        </Col>
      </Row>
    </Drawer>
    <!-- 详情弹层 end -->
    <!-- 发货弹框 -->
    <Form :model="shipdata"
          ref="logisticValidate"
          :rules="logisticValidate"
          action="javascript:void(0)">
      <Modal v-model="showCreatTypeModal"
             title="发货"
             @on-ok="shipOrder('logisticValidate')"
             :loading="dataloading">
        <FormItem label="请选择快递">
          <Select :label-in-value="true"
                  v-model="loginst"
                  @on-change="perChange"
                  clearable
                  filterable
                  placeholder="选择快递">
            <Option v-for="item in selectLogistics"
                    :value="item.id"
                    :key="item.id">{{item.name}}</Option>
          </Select>
        </FormItem>
        <FormItem label="快递单号"
                  prop="logistics_code">
          <Input v-model="shipdata.logistics_code"
                 placeholder />
        </FormItem>
        <FormItem label="商家备注"
                  prop="shop_mark">
          <Input v-model="shipdata.shop_mark"
                 placeholder />
        </FormItem>
      </Modal>
    </Form>

    <!-- 发货弹框 end -->
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.current"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
    <!-- 图片查看 start -->
    <viewer :options="viewerOptions"
            :images="viewerImages"
            @inited="inited"
            class="viewerImageWraper"
            ref="viewerImageWraper">
      <template slot-scope="scope">
        <figure class="images">
          <div class="image-wrapper"
               v-for="img in viewerImages"
               :key="img">
            <img class="image"
                 :src="img"
                 :data-source="img"
                 :alt="img"
                 style="display: none;" />
          </div>
        </figure>
      </template>
    </viewer>
    <!-- 图片查看 end -->

    <!-- 修改平台进价弹框 -->
    <Modal v-model="showPlatPriceModal"
           title="平台进价"
           @on-ok="editPlatPrice('platpriceValidate')"
           :loading="dataloading">
      <Form :model="platpriceInfo"
            ref="platpriceValidate"
            :rules="platpriceValidate"
            action="javascript:void(0)">
        <FormItem label="平台进价"
                  prop="platprice">
          <Input v-model="platpriceInfo.platprice"
                 type="number"
                 placeholder />
        </FormItem>
      </Form>
    </Modal>
    <!-- 修改平台进价 end -->
    <!-- 批量发货的弹出 -->
    <Modal v-model="showImportModalStatus"
           title="导入任务"
           @on-ok="importCar()"
           :loading="exportLoading">
      <Form :model="leadIn"
            action="javascript:void(0)">
        <FormItem label="选择文件">
          <!--<upload-question v-model="leadIn.filePath" :defaultList="fileListThree" ref="import-filesThree"></upload-question>-->
          <file-import v-model="leadIn.file_url"
                       :defaultList="fileListThree"
                       ref="import-filesThree"></file-import>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import expandRow from "./table-expand";
import FileImport from "../common/fileimport";

export default {
  name: "goods-order",
  data () {
    const validatelogisticscode = (rule, value, callback) => {
      if (this.shipdata.logistics_code == "") {
        callback(new Error("快递编号必须填写"));
      } else {
        callback();
      }
    };
    const validateshopmark = (rule, value, callback) => {
      if (this.shipdata.shop_mark == "") {
        callback(new Error("店铺备注必须填写"));
      } else {
        callback();
      }
    };

    return {
      modal1: false, // 订单规格弹层显示状态
      exportLoading: false,
      leadIn: {},
      showImportModalStatus: false,
      dataloading: true,
      detaildata: [],
      selectLogistics: [],
      fileListThree: [],
      showCreatTypeModal: false,
      wxreturnmoney_status: false,
      wxreturnmoney_method: false,
      formItem: {
        key: "",
        pay_name: "",
      },
      loginst: [],
      shipdata: {
        logistic_id: 0,
        name: "",
        code: ""
      },
      pages: {
        current: 1,
        total: 0,
        size: 10
      },
      payStatusList: [
        { id: 0, name: "未支付" },
        { id: 1, name: "支付中" },
        { id: 2, name: "已完成" }
      ],
      statusList: [
        { id: 0, name: "关闭" },
        { id: 1, name: "正常" },
        { id: 2, name: "完成" }
      ],
      shipList: [
        { id: 0, name: "未发货" },
        { id: 1, name: "已发货" }
      ],
      receiptStatusList: [
        { id: 0, name: "未收货" },
        { id: 1, name: "已收货" }
      ],
      payNameList: [
        { id: 0, name: "融宝" },
        { id: 1, name: "财付通" },],
      list: [
        // {
        //     type: 'expand',
        //     render: (h, params) => {
        //         return h(ordergood, {
        //             props: {
        //                 row: params.row
        //             }
        //         })
        //     }
        // },
        {
          title: "",
          type: "expand",
          width: 30,
          // fixed:"left",
          // expand: true,
          render: (h, params) => {
            let that = this;
            return h(expandRow, {
              props: {
                // _expanded:true,
                row: params.row.ordergood,
                showViewerFun: () => {
                  let imgs = [];
                  console.log(params.row.ordergood);
                  for (var i in params.row.ordergood) {
                    imgs.push(params.row.ordergood[i].good_thumb);
                  }
                  that.viewerImages = imgs;
                  console.log(that.viewerImages);
                  that.$viewer.show();
                }
              }
            });
          }
        },
        {
          title: "订单编号",
          align: "center",
          key: "order_num",
          minWidth: 185
        },
        {
          title: "支付单号",
          align: "center",
          key: "pay_order_num",
          minWidth: 185
        },
        {
          title: "会员名",
          minWidth: 140,
          align: "center",
          key: "username"
        },
        {
          title: "邮费",
          minWidth: 100,
          align: "center",
          key: "fare"
        },
        {
          title: "商品价格",
          minWidth: 100,
          align: "center",
          key: "old_prices"
        },
        {
          title: "折扣",
          minWidth: 100,
          align: "center",
          key: "discount"
        },
        {
          title: "商品折后价",
          minWidth: 100,
          align: "center",
          key: "real_prices"
        },
        {
          title: "实付款（元）",
          minWidth: 140,
          align: "center",
          key: "total_price"
        },
        {
          title: "支付方式",
          minWidth: 130,
          align: "center",
          key: "pay_name"
        },
        {
          title: "订单状态",
          minWidth: 100,
          align: "center",
          key: "status",
          render: (h, params) => {
            return h(
              "tag",
              {
                props: {
                  color:
                    params.row.status == "2"
                      ? "success"
                      : params.row.status == "1"
                        ? "green" // orange
                        : "red" // geekblue
                }
              },
              params.row.status == "0"
                ? "关闭"
                : params.row.status == "1"
                  ? "正常"
                  : params.row.status == "3"
                    ? "退款中"
                    : "完成"
            );
          }
        },
        {
          title: "支付状态",
          minWidth: 100,
          align: "center",
          key: "pay_status",
          render: (h, params) => {
            return h(
              "div",
              params.row.pay_status == "0"
                ? "未支付"
                : params.row.pay_status == "1"
                  ? "支付中"
                  : "已完成"
            );
          }
        },
        {
          title: "收货地址",
          key: "address",
          width: 220,
          tooltip: true
        },
        {
          title: "快递名称",
          key: "logistics_name",
          width: 150,
          tooltip: true
        },
        {
          title: "快递单号",
          key: "logistics_code",
          width: 150,
          tooltip: true
        },
        {
          title: "发货状态",
          minWidth: 100,
          align: "center",
          key: "ship_status",
          render: (h, params) => {
            return h(
              "tag",
              {
                props: {
                  color: params.row.ship_status == "1" ? "geekblue" : "red"
                }
              },
              params.row.ship_status == "1" ? "已发货" : "未发货"
            );
          }
        },
        {
          title: "收货状态",
          minWidth: 100,
          align: "center",
          key: "receipt_status",
          render: (h, params) => {
            return h(
              "tag",
              {
                props: {
                  color: params.row.receipt_status == "1" ? "geekblue" : "red"
                }
              },
              params.row.receipt_status == "1" ? "已收货" : "未收货"
            );
          }
        },
        // {
        //     title: '邮寄方式',
        //     minWidth: 100,
        //     align: "center",
        //     key: 'fare_type',
        //     render: (h, params) => {
        //         // return h('div', params.row.fare_type == "1" ? '自提' : '邮寄')
        //         return h('tag',
        //             {
        //                 props: {
        //                     color: params.row.fare_type == "1" ?'geekblue':'red',
        //                 }
        //             },
        //             params.row.fare_type == "1" ? '自提' : '邮寄')
        //     }
        // },
        {
          title: "下单时间",
          minWidth: 150,
          align: "center",
          key: "created_at"
          // fixed:'right'
        },
        {
          title: "操作",
          align: "center",
          key: "action",
          width: 160,
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "info",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      this.detail(params.row.id);
                    }
                  }
                },
                "详情"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px",
                    display:
                      params.row.status == "1" &&
                        params.row.pay_status == "2" &&
                        params.row.ship_status == "0"
                        ? "inline-block"
                        : "none"
                  },
                  on: {
                    click: () => {
                      this.ship(params.row.id);
                    }
                  }
                },
                "发货"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px",
                    display:
                      params.row.status == "1" &&
                        params.row.receipt_status == "0"
                        ? "inline-block"
                        : "none"
                  },
                  on: {
                    click: () => {
                      this.close(params.row.id);
                    }
                  }
                },
                "关闭"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "warning",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px",
                    display:
                      params.row.status == 2 && this.is_platprice == 1
                        ? "inline-block"
                        : "none"
                  },
                  on: {
                    click: () => {
                      this.platprice(
                        params.row.id,
                        params.row.ordergood[0].platprice
                      );
                    }
                  }
                },
                "平台进价"
              )
            ]);
          }
        }
      ],
      tablelist: [],
      //订单详情
      columsgood: [
        {
          title: "产品名称",
          key: "good_title",
          width: 200,
          align: "center"
        },
        {
          title: "产品规格",
          width: 100,
          key: "good_spec_name",
          align: "center"
        },
        {
          title: "数量",
          width: 70,
          key: "nums",
          align: "center"
        },
        {
          title: "单价（元）",
          width: 120,
          key: "price",
          align: "center"
        },
        {
          title: "总价（元）",
          width: 120,
          key: "total_prices",
          align: "center"
        },
        {
          title: "状态",
          align: "center",
          key: "status",
          minWidth: 80,
          render: (h, params) => {
            return h("div", params.row.status == 1 ? "退回" : "正常");
          }
        }
      ],
      datagood: [],
      viewerImages: [], // v-viewer图片列表
      viewerOptions: {
        toolbar: true,
        url: "data-source"
      },
      $viewer: null,
      logisticValidate: {
        logistics_code: [
          { required: true, validator: validatelogisticscode, trigger: "blur" }
        ],
        shop_mark: [
          { required: true, validator: validateshopmark, trigger: "blur" }
        ]
      },
      platpriceInfo: {
        order_id: 0,
        platprice: 0
      },
      platpriceValidate: {},
      showPlatPriceModal: false //平台进价弹窗
    };
  },
  // 计算
  components: {
    expandRow,
    FileImport
  },
  // 监听
  watch: {
    "$route.params": function (n, o) {
      if (n) {
        this.order_id = this.$route.params.id;
        // 取数据
        this.is_platprice = this.$route.params.is_platprice;
        // 取数据
        this.getTableList();
        //取快递数据
        this.getLogisticList();
      }
    }
  },
  created: function () {
    this.order_id = this.$route.params.id;
    this.is_platprice = this.$route.params.is_platprice;
    // 取数据
    this.formItem.pay_status = this.$route.params.pay_status != -1 ? parseInt(this.$route.params.pay_status) : null;
    this.formItem.ship_status = this.$route.params.ship_status != -1 ? parseInt(this.$route.params.ship_status) : null
    this.formItem.status = this.$route.params.order_status != -1 ? parseInt(this.$route.params.order_status) : null;

  },
  mounted: function () {
    this.is_platprice = this.$route.params.is_platprice;
    // 取数据
    this.getTableList();
    //取快递数据
    this.getLogisticList();
  },
  updated: function () { },
  methods: {
    inited (viewer) {
      this.$viewer = viewer;
    },
    // 获取订单列表
    getTableList: function () {
      var params = {
        is_platprice: this.is_platprice,
        page: this.pages.current,
        size: this.pages.size,
        pay_status: this.formItem.pay_status,
        ship_status: this.formItem.ship_status,
        status: this.formItem.status
      };
      this.$api.goodorder.list(params).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          // this.payNameList = res.result.payNameList;
          this.$Message.success(res.msg);
          if (this.tablelist.length > 0) {
            for (var i = 0; i < 10; i++) {
              this.tablelist[i]._expanded = true;
            }
          }
        }
      });
      return;
    },
    //获取快递列表
    getLogisticList () {
      var params = {
        page: 1,
        size: 10000
      };
      this.$api.logistics.list(params).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.selectLogistics = res.result.list;
        }
      });
    },
    // 分页
    changePage () {
      this.pages.page = this.$refs["listPage"].currentPage;
      this.renderTable(1);
    },

    //平台进价
    platprice: function (id, platprice) {
      this.showPlatPriceModal = !this.showPlatPriceModal;
      this.platpriceInfo = {
        order_id: id,
        platprice: platprice
      };
    },
    editPlatPrice: function (name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.$api.goodorder.editPlatprice(this.platpriceInfo).then(res => {
            if (res.code == 200) {
              this.getTableList();
              this.showPlatPriceModal = false;
            }
          });
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
        } else {
          this.$Message.error("请检查输入的信息是否正确！");
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
        }
      });
    },

    // 查看详情
    detail: function (index) {
      this.modal1 = true;
      var params = {
        order_id: index
      };
      this.$api.goodorder.detail(params).then(res => {
        if (res.code == 200) {
          this.datagood = res.result.ordergood;
          this.detaildata.pay_order_num = res.result.pay_order_num;
          this.detaildata.order_num = res.result.order_num;
          this.detaildata.pay_name = res.result.pay_name;
          this.detaildata.person = res.result.person;
          this.detaildata.phone = res.result.phone;
          this.detaildata.address = res.result.address;
          this.detaildata.logistics_name = res.result.logistics_name;
          this.detaildata.logistics_code = res.result.logistics_code;
          this.detaildata.wxreturn_code = res.result.wxreturn_code;
          this.detaildata.wxreturn_msg = res.result.wxreturn_msg;
          this.detaildata.wxreturn_msg2 = res.result.wxreturn_msg2;
          this.detaildata.wxreturn_status = res.result.wxreturn_status;
          if (res.result.pay_method == 1) {
            this.wxreturnmoney_method = true;
          }
          if (res.result.pay_method == 1 && res.result.order_status == 3) {
            this.wxreturnmoney_status = true;
            this.detaildata.wxreturnmoney_status =
              res.result.wxreturnmoney_status;
          }
        }
      });
      return;
    },
    close: function (index) {
      // 弹出确认框
      this.$Modal.confirm({
        title: "警告",
        content: "<p>此操作不可恢复，三思而后行...</p>",
        onOk: () => {
          this.$api.goodorder.close({ order_id: index }).then(res => {
            if (res.code == 200) {
              this.$Message.success(res.msg);
              // this.tablelist.splice(index, 1);
              this.getTableList();
            }
          });
        }
      });
    },
    // 导入
    showImportModel: function () {
      this.showImportModalStatus = !this.showImportModalStatus;
      this.fileListThree = [];
      this.leadIn.file_url = "";
    },
    ship: function (index) {
      this.id = index;
      this.shipdata.shop_mark = "";
      this.shipdata.logistics_code = "";
      this.logistics_id = 0;
      this.loginst = [];
      this.showCreatTypeModal = true;
    },
    perChange: function (index) {
      this.logistics_id = index.value;
      this.logistics_name = index.label;
    },
    shipOrder: function (name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          let params = {
            id: this.id,
            logistics_id: this.logistics_id,
            shop_mark: this.shipdata.shop_mark, // 备注
            logistics_name: this.logistics_name,
            logistics_code: this.shipdata.logistics_code // 快递单号
          };
          this.$api.goodorder.ship(params).then(res => {
            if (res.code == 200) {
              this.showCreatTypeModal = false;
              this.getTableList();
            }
          });
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
        } else {
          this.$Message.error("请检查输入的信息是否正确！");
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
        }
      });
    },
    // 筛选
    renderTable: function (name) {
      if (name != 1) {
        this.pages.page = 1;
      }
      let params = {
        is_platprice: this.is_platprice,
        page: this.pages.page,
        size: this.pages.size,
        key: this.formItem.key,
        name: this.formItem.name,
        pay_name: this.formItem.pay_name,
        status: this.formItem.status,
        receipt_status: this.formItem.receipt_status,
        pay_status: this.formItem.pay_status,
        ship_status: this.formItem.ship_status,
        pay_order_num: this.formItem.pay_order_num
      };
      this.$api.goodorder.list(params).then(res => {
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
          if (this.tablelist.length > 0) {
            for (var i = 0; i < 10; i++) {
              this.tablelist[i]._expanded = true;
            }
          }
        }
      });
    },
    exportOrder () {
      this.exportLoading = true;
      this.$api.goodorder
        .unshipgoodorder({
          is_platprice: this.is_platprice
        })
        .then(res => {
          if (res.code == 200) {
            this.$Message.success(res.msg);
          }
          this.exportLoading = false;
        });
    },
    importCar (name) {
      if (
        this.$refs["import-filesThree"].resList != undefined &&
        this.$refs["import-filesThree"].resList.length
      ) {
        this.leadIn.file_url = this.$refs["import-filesThree"].resList[0].url;
      } else {
        this.leadIn.file_url = "";
        this.$Message.error("请选择上传文件");
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true;
        });
        return;
      }
      this.$api.goodorder.allshipgoodorder(this.leadIn).then(res => {
        this.loading = false;
        if (res.code == 200) {
          this.$Message.success(res.msg);
          this.showImportModalStatus = false;
          this.renderTable(1);
        }
      });
    }
  }
};
</script>
<style scoped>
.viewer-next,
.viewer-prev,
.viewer-play {
  display: none;
}
</style>